import { isArticlePage, isAuthorMode, isLiveBlogPage } from '../../utils/aem-utils';
import { isHomepageInArticle } from '../../utils/injected-hp-utils';

export const parselyRenderModule = {
  name: 'Parsely Render',
};

export const parselyRenderRailMostViewedModule = {
  name: 'Parsely Render Most Viewed',
};

export const tvCardRailChangePositionModule = {
  name: 'Tv Card Rail Change Position',
};

export const tvCardSlimModule = {
  name: 'Tv Card Slim',
};
